<template>
    <div class="points">
        <!--        <div class="actions__container">-->
        <!--            <div>-->
        <!--                <router-link class="btn btn-primary w-40 inline-block mr-1 mb-2" :to="{ name: 'point-create' }">-->
        <!--                    Создать-->
        <!--                </router-link>-->
        <!--            </div>-->
        <!--        </div>-->

        <RoutePointsContentSearch class="mb-4" />

        <ContentTable
            :table-actions="tableActions"
            :headers="tableHeaders"
            :table-rows="tableData"
            :meta="pagination"
            :loading="loading"
            @edit="editAction"
            @delete="deleteAction"
        />

        <PopupDeleteModal
            :is-open="modalDeleteOpen"
            :entity-name="modalDeleteCaption"
            :modal-data="modalDeleteRow"
            @update:isOpen="modalDeleteOpen = $event"
            @deleteModalAccepted="onDeleteModalAccepted"
        />
    </div>
</template>

<script>
import ContentTable from '@/components/tables/ContentTable';
import PopupDeleteModal from '@/components/modals/PopupDeleteModal';
import { pageMixin } from '@/mixins/pageMixin';
import RoutePointsContentSearch from '@/components/route-points/RoutePointsContentSearch.vue';

export default {
    name: 'Main',
    components: { RoutePointsContentSearch, PopupDeleteModal, ContentTable },
    mixins: [pageMixin],
    async beforeRouteUpdate(to, from, next) {
        await this.fetchData({ ...to.query });
        next();
    },
    data() {
        return {
            tableActions: [
                { name: 'edit', title: 'редактировать', icon: 'Edit2Icon', cbName: 'edit' },
                // { name: 'delete', title: 'удалить', class: 'bg-red-400', icon: 'Trash2Icon', cbName: 'delete' },
            ],
            addButtonDelete: false,
            tableHeaders: [
                { field: 'id', label: '#' },
                { field: 'title', label: 'Название' },
            ],
            loading: false,
            tableData: [],
            pagination: null,
            modalDeleteOpen: false,
            modalDeleteCaption: null,
            modalDeleteRow: null,
        };
    },
    async created() {
        this.$store.commit('main/setPageHeader', 'Локации');
        await this.fetchData(this.$route.query);
    },
    methods: {
        async fetchData(params) {
            try {
                this.loading = true;
                const { data } = await this.axios.get('/points', { params });
                this.tableData = data.data;
                this.pagination = data.meta;

                this.loading = false;
            } catch (ex) {
                this.loading = false;
                console.log('cant fetch data: ' + ex);
            }
        },

        editAction(row) {
            this._pMTransitionToEditPageWithQuery('point-edit', { id: row.id });
        },
        deleteAction(row) {
            this.modalDeleteOpen = true;
            this.modalDeleteCaption = 'направление';
            this.modalDeleteRow = row;
        },
        onDeleteModalAccepted(data) {
            this.axios
                .delete('/points/' + data.id)
                .then((res) => {
                    this.fetchData(this.$route.query);
                    this.modalDeleteOpen = false;
                })
                .catch((ex) => {
                    this.$notify({
                        title: 'Ошибка',
                        text: ex.response.data.message,
                        type: 'error',
                    });
                });
        },
    },
};
</script>

<style scoped></style>
